module.exports = __webpack_public_path__ + "static/media/download-circle.94e430e2.svg";